export const ACTION_USER_LIST_PRODUCTS = "ACTION_USER_LIST_PRODUCTS";

export const ACTION_INITIAL_USER_PRODUCT_DETAIL = "ACTION_INITIAL_USER_PRODUCT_DETAIL";

export const ACTION_PRODUCT_DETAIL_USER = "ACTION_PRODUCT_DETAIL_USER";

export const ACTION_ASSOCIATE_PRODUCT = "ACTION_ASSOCIATE_PRODUCT";

export const ACTION_CREATE_ASSOCIATE_PRODUCT = "ACTION_CREATE_ASSOCIATE_PRODUCT";

export const ACTION_UPDATE_ASSOCIATE_PRODUCT = "ACTION_UPDATE_ASSOCIATE_PRODUCT";

export const ACTION_CALL_LIST_COMPANY_PROVIDERS = "ACTION_CALL_LIST_COMPANY_PROVIDERS"
export const ACTION_CALL_LIST_CATEGORIES_COMMERCIAL_FILTER_PROVIDER = "ACTION_CALL_LIST_CATEGORIES_COMMERCIAL_FILTER_PROVIDER";
export const ACTION_CALL_LIST_TYPES_PRODUCTS_CATEGORY = "ACTION_CALL_LIST_TYPES_PRODUCTS_CATEGORY";
export const ACTION_CALL_LIST_PRODUCTS_FILTER_TYPE_PRODUCT = "ACTION_CALL_LIST_PRODUCTS_FILTER_TYPE_PRODUCT"
export const ACTION_CALL_LIST_NUMBER_CONTRACT_FILTER_COMPANY = "ACTION_CALL_LIST_NUMBER_CONTRACT_FILTER_COMPANY"
export const ACTION_CALL_POLICY_PRODUCT = "ACTION_CALL_POLICY_PRODUCT";
export const ACTION_CALL_LIST_TYPES_CONTRACTS = "ACTION_CALL_LIST_TYPES_CONTRACTS";




